import PF_SectionOne from "./PF_SectionOne";
import "./ProductsFull.scss";

function ProductsFull() {
  return (
    <>
      <main>
        <PF_SectionOne />
      </main>
    </>
  );
}

export default ProductsFull;
